var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return this.uiVersion == 3
    ? _c("PostV3", {
        attrs: {
          guid: _vm.post.guid,
          title: this.formattedTitle,
          featuredImageUrl: this.featuredImageUrl,
          formattedDate: this.formattedDate,
          formattedDescription: this.formattedDescription
        }
      })
    : this.uiVersion == 2
    ? _c("PostV2", {
        attrs: {
          guid: _vm.post.guid,
          title: this.formattedTitle,
          featuredImageUrl: this.featuredImageUrl,
          formattedDate: this.formattedDate,
          formattedDescription: this.formattedDescription
        }
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }